const globalTheme = {};

export default globalTheme;
